import type { ComponentType, SVGAttributes } from "react";
import Range from "~/public/icons/range.svg";
import Precision from "~/public/icons/precision.svg";
import VerticalResolution from "~/public/icons/vertical-resolution.svg";
import HorizontalResolution from "~/public/icons/horizontal-resolution.svg";
import Weight from "~/public/icons/weight.svg";
export const translations = {
  requestQuote: {
    en: "Request Quote",
    zh: "请求报价",
    ja: "見積もりをリクエスト",
    ko: "견적 요청"
  },
  download: {
    en: "Download",
    zh: "下载",
    ja: "ダウンロード",
    ko: "다운로드"
  },
  downloadSpecs: {
    en: "Download Specifications",
    zh: "下载规格",
    ja: "仕様書をダウンロード",
    ko: "사양 다운로드"
  },
  hide: {
    en: "Hide",
    zh: "隐藏",
    ja: "非表示",
    ko: "숨기기"
  },
  show: {
    en: "Show",
    zh: "显示",
    ja: "表示",
    ko: "표시"
  }
} as const;

// Icon keys authored in the Studio (`hardwareComparisonSpec.icon`) map to SVGs
// bundled with the frontend. Add new pictographs by dropping an SVG in
// `apps/web/public/icons/` and adding both an entry here and a matching option
// in `apps/studio/schemas/page-builder-custom/hardware-comparison-tables.ts`.
export const specIcons: Record<string, ComponentType<SVGAttributes<SVGElement>>> = {
  range: Range,
  precision: Precision,
  "vertical-resolution": VerticalResolution,
  "horizontal-resolution": HorizontalResolution,
  weight: Weight
};